import { styled } from '@mui/material/styles';
import { MuiDrawer } from '../../../../../modules/material';

export const StyledDrawer = styled(MuiDrawer)(() => ({}));
